import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "py-20 bg-neutral-900" }
const _hoisted_2 = { class: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" }
const _hoisted_3 = { class: "flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-12" }
const _hoisted_4 = {
  key: 0,
  class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
}
const _hoisted_5 = { class: "flex gap-1 mb-4" }
const _hoisted_6 = {
  key: 1,
  class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
}
const _hoisted_7 = { class: "flex gap-0.5 mb-4" }
const _hoisted_8 = {
  key: 0,
  class: "text-white font-semibold text-sm mb-2"
}
const _hoisted_9 = { class: "text-neutral-400 text-sm leading-relaxed flex-1 italic" }
const _hoisted_10 = { class: "flex items-center gap-3 mt-6 pt-5 border-t border-white/10" }
const _hoisted_11 = { class: "min-w-0" }
const _hoisted_12 = { class: "font-bold text-white text-sm truncate" }
const _hoisted_13 = {
  key: 0,
  class: "text-xs text-neutral-500 truncate mt-0.5"
}
const _hoisted_14 = { class: "text-xs text-neutral-600 mt-0.5" }
const _hoisted_15 = {
  key: 2,
  class: "text-center py-16"
}
const _hoisted_16 = {
  key: 3,
  class: "mt-10 flex flex-col sm:flex-row items-center justify-center gap-6"
}
const _hoisted_17 = { class: "text-center" }
const _hoisted_18 = { class: "text-5xl font-extrabold text-white leading-none" }
const _hoisted_19 = { class: "flex justify-center gap-0.5 mt-2" }
const _hoisted_20 = { class: "text-neutral-500 text-xs mt-1" }
const _hoisted_21 = { class: "relative bg-white rounded-3xl shadow-2xl w-full max-w-lg mx-auto overflow-hidden" }
const _hoisted_22 = { class: "bg-gradient-to-r from-primary-500 to-primary-600 px-8 py-6" }
const _hoisted_23 = { class: "flex items-center justify-between" }
const _hoisted_24 = {
  key: 0,
  class: "px-8 py-12 text-center"
}
const _hoisted_25 = { class: "flex items-center gap-1" }
const _hoisted_26 = ["onClick", "onMouseover"]
const _hoisted_27 = { class: "ml-2 text-sm text-neutral-500" }
const _hoisted_28 = {
  key: 0,
  class: "text-red-500 text-xs mt-1"
}
const _hoisted_29 = {
  key: 0,
  class: "text-red-500 text-xs mt-1"
}
const _hoisted_30 = {
  key: 0,
  class: "text-red-500 text-xs mt-1"
}
const _hoisted_31 = { class: "flex gap-3 pt-2" }
const _hoisted_32 = ["disabled"]
const _hoisted_33 = {
  key: 0,
  class: "w-4 h-4 animate-spin",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[11] || (_cache[11] = _createElementVNode("div", null, [
          _createElementVNode("p", { class: "text-primary-400 text-sm font-semibold uppercase tracking-widest mb-2" }, "Client Stories"),
          _createElementVNode("h2", { class: "text-3xl md:text-4xl font-bold text-white leading-tight" }, " What Our Clients Say ")
        ], -1)),
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModal = true)),
          class: "inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white text-sm font-semibold px-5 py-3 rounded-xl transition-colors shadow-lg flex-shrink-0"
        }, [...(_cache[10] || (_cache[10] = [
          _createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            viewBox: "0 0 24 24",
            stroke: "currentColor"
          }, [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M12 4v16m8-8H4"
            })
          ], -1),
          _createTextVNode(" Share Your Story ", -1)
        ]))])
      ]),
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (i) => {
              return _createElementVNode("div", {
                key: i,
                class: "bg-white/5 rounded-2xl p-7 animate-pulse"
              }, [
                _createElementVNode("div", _hoisted_5, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (s) => {
                    return _createElementVNode("div", {
                      key: s,
                      class: "w-4 h-4 bg-white/10 rounded"
                    })
                  }), 64))
                ]),
                _cache[12] || (_cache[12] = _createStaticVNode("<div class=\"space-y-2 mb-6\" data-v-6cffe954><div class=\"h-3 bg-white/10 rounded w-full\" data-v-6cffe954></div><div class=\"h-3 bg-white/10 rounded w-4/5\" data-v-6cffe954></div><div class=\"h-3 bg-white/10 rounded w-3/5\" data-v-6cffe954></div></div><div class=\"flex items-center gap-3 pt-5 border-t border-white/10\" data-v-6cffe954><div class=\"w-10 h-10 rounded-full bg-white/10\" data-v-6cffe954></div><div class=\"space-y-1.5\" data-v-6cffe954><div class=\"h-3 bg-white/10 rounded w-24\" data-v-6cffe954></div><div class=\"h-2.5 bg-white/10 rounded w-32\" data-v-6cffe954></div></div></div>", 2))
              ])
            }), 64))
          ]))
        : (_ctx.reviews.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reviews, (review) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: review.id,
                  class: "bg-white/5 border border-white/10 rounded-2xl p-7 flex flex-col hover:bg-white/8 hover:border-white/20 transition-all duration-300"
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (n) => {
                      return _createElementVNode("svg", {
                        key: n,
                        class: _normalizeClass(["w-4 h-4 transition-colors", n <= review.rating ? 'text-yellow-400' : 'text-white/20']),
                        fill: "currentColor",
                        viewBox: "0 0 20 20"
                      }, [...(_cache[13] || (_cache[13] = [
                        _createElementVNode("path", { d: "M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" }, null, -1)
                      ]))], 2)
                    }), 64))
                  ]),
                  (review.title)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(review.title), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("p", _hoisted_9, "\"" + _toDisplayString(review.message) + "\"", 1),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", {
                      class: "w-10 h-10 rounded-full flex items-center justify-center text-white font-bold text-sm flex-shrink-0",
                      style: _normalizeStyle({ background: _ctx.avatarGradient(review.id) })
                    }, _toDisplayString(_ctx.nameInitials(review.name)), 5),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("p", _hoisted_12, _toDisplayString(review.name), 1),
                      (review.detail)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(review.detail), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.formatDate(review.created_at)), 1)
                    ])
                  ])
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_15, [...(_cache[14] || (_cache[14] = [
              _createStaticVNode("<div class=\"w-16 h-16 bg-white/5 rounded-full flex items-center justify-center mx-auto mb-4\" data-v-6cffe954><svg class=\"w-8 h-8 text-neutral-500\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\" data-v-6cffe954><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.5\" d=\"M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z\" data-v-6cffe954></path></svg></div><p class=\"text-neutral-400 text-base mb-2\" data-v-6cffe954>No reviews yet</p><p class=\"text-neutral-600 text-sm\" data-v-6cffe954>Be the first to share your experience with Estate Rwanda.</p>", 3)
            ]))])),
      (!_ctx.isLoading && _ctx.reviews.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.averageRating), 1),
              _createElementVNode("div", _hoisted_19, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (n) => {
                  return _createElementVNode("svg", {
                    key: n,
                    class: _normalizeClass(["w-4 h-4", n <= Math.round(+_ctx.averageRating) ? 'text-yellow-400' : 'text-white/20']),
                    fill: "currentColor",
                    viewBox: "0 0 20 20"
                  }, [...(_cache[15] || (_cache[15] = [
                    _createElementVNode("path", { d: "M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" }, null, -1)
                  ]))], 2)
                }), 64))
              ]),
              _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.total) + " review" + _toDisplayString(_ctx.total !== 1 ? 's' : ''), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_Transition, { name: "modal-fade" }, {
      default: _withCtx(() => [
        (_ctx.showModal)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 z-50 flex items-center justify-center p-4",
              onClick: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["self"]))
            }, [
              _cache[26] || (_cache[26] = _createElementVNode("div", { class: "absolute inset-0 bg-black/70 backdrop-blur-sm" }, null, -1)),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _cache[17] || (_cache[17] = _createElementVNode("div", null, [
                      _createElementVNode("h3", { class: "text-xl font-bold text-white" }, "Share Your Experience"),
                      _createElementVNode("p", { class: "text-primary-100 text-sm mt-0.5" }, "Help others find their perfect property")
                    ], -1)),
                    _createElementVNode("button", {
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
                      class: "w-8 h-8 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center text-white transition-colors"
                    }, [...(_cache[16] || (_cache[16] = [
                      _createElementVNode("svg", {
                        class: "w-4 h-4",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2.5",
                          d: "M6 18L18 6M6 6l12 12"
                        })
                      ], -1)
                    ]))])
                  ])
                ]),
                (_ctx.submitSuccess)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [...(_cache[18] || (_cache[18] = [
                      _createElementVNode("div", { class: "w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4" }, [
                        _createElementVNode("svg", {
                          class: "w-8 h-8 text-emerald-500",
                          fill: "none",
                          viewBox: "0 0 24 24",
                          stroke: "currentColor"
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M5 13l4 4L19 7"
                          })
                        ])
                      ], -1),
                      _createElementVNode("h4", { class: "text-xl font-bold text-neutral-800 mb-2" }, "Thank You!", -1),
                      _createElementVNode("p", { class: "text-neutral-500 text-sm" }, "Your review is now live and visible to everyone.", -1)
                    ]))]))
                  : (_openBlock(), _createElementBlock("form", {
                      key: 1,
                      onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitReview && _ctx.submitReview(...args)), ["prevent"])),
                      class: "px-8 py-6 space-y-5"
                    }, [
                      _createElementVNode("div", null, [
                        _cache[20] || (_cache[20] = _createElementVNode("label", { class: "block text-sm font-semibold text-neutral-700 mb-2" }, [
                          _createTextVNode(" Your Rating "),
                          _createElementVNode("span", { class: "text-red-500" }, "*")
                        ], -1)),
                        _createElementVNode("div", _hoisted_25, [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (n) => {
                            return _createElementVNode("button", {
                              key: n,
                              type: "button",
                              onClick: ($event: any) => (_ctx.form.rating = n),
                              onMouseover: ($event: any) => (_ctx.hoverRating = n),
                              onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.hoverRating = 0)),
                              class: "transition-transform hover:scale-110"
                            }, [
                              (_openBlock(), _createElementBlock("svg", {
                                class: _normalizeClass(["w-9 h-9 transition-colors", n <= (_ctx.hoverRating || _ctx.form.rating) ? 'text-yellow-400' : 'text-neutral-200']),
                                fill: "currentColor",
                                viewBox: "0 0 20 20"
                              }, [...(_cache[19] || (_cache[19] = [
                                _createElementVNode("path", { d: "M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" }, null, -1)
                              ]))], 2))
                            ], 40, _hoisted_26)
                          }), 64)),
                          _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.ratingLabel), 1)
                        ]),
                        (_ctx.errors.rating)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_28, _toDisplayString(_ctx.errors.rating), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", null, [
                        _cache[21] || (_cache[21] = _createElementVNode("label", { class: "block text-sm font-semibold text-neutral-700 mb-1.5" }, [
                          _createTextVNode(" Your Name "),
                          _createElementVNode("span", { class: "text-red-500" }, "*")
                        ], -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.name) = $event)),
                          type: "text",
                          placeholder: "e.g. Alice Mukamana",
                          class: "w-full px-4 py-3 border border-neutral-200 rounded-xl text-sm text-neutral-700 placeholder-neutral-400 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent transition"
                        }, null, 512), [
                          [_vModelText, _ctx.form.name]
                        ]),
                        (_ctx.errors.name)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString(_ctx.errors.name), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", null, [
                        _cache[22] || (_cache[22] = _createElementVNode("label", { class: "block text-sm font-semibold text-neutral-700 mb-1.5" }, [
                          _createTextVNode(" Review Title "),
                          _createElementVNode("span", { class: "text-neutral-400 font-normal" }, "(optional)")
                        ], -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.title) = $event)),
                          type: "text",
                          placeholder: "e.g. Excellent service, highly recommend!",
                          class: "w-full px-4 py-3 border border-neutral-200 rounded-xl text-sm text-neutral-700 placeholder-neutral-400 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent transition"
                        }, null, 512), [
                          [_vModelText, _ctx.form.title]
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _cache[23] || (_cache[23] = _createElementVNode("label", { class: "block text-sm font-semibold text-neutral-700 mb-1.5" }, [
                          _createTextVNode(" Your Review "),
                          _createElementVNode("span", { class: "text-red-500" }, "*")
                        ], -1)),
                        _withDirectives(_createElementVNode("textarea", {
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.message) = $event)),
                          rows: "4",
                          placeholder: "Tell us about your experience with Estate Rwanda...",
                          class: "w-full px-4 py-3 border border-neutral-200 rounded-xl text-sm text-neutral-700 placeholder-neutral-400 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent transition resize-none"
                        }, null, 512), [
                          [_vModelText, _ctx.form.message]
                        ]),
                        (_ctx.errors.message)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_30, _toDisplayString(_ctx.errors.message), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", null, [
                        _cache[24] || (_cache[24] = _createElementVNode("label", { class: "block text-sm font-semibold text-neutral-700 mb-1.5" }, [
                          _createTextVNode(" Transaction Detail "),
                          _createElementVNode("span", { class: "text-neutral-400 font-normal" }, "(optional)")
                        ], -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.detail) = $event)),
                          type: "text",
                          placeholder: "e.g. Bought an Apartment in Kiyovu, Kigali",
                          class: "w-full px-4 py-3 border border-neutral-200 rounded-xl text-sm text-neutral-700 placeholder-neutral-400 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent transition"
                        }, null, 512), [
                          [_vModelText, _ctx.form.detail]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
                          class: "flex-1 px-5 py-3 border border-neutral-200 text-neutral-600 text-sm font-semibold rounded-xl hover:bg-neutral-50 transition-colors"
                        }, " Cancel "),
                        _createElementVNode("button", {
                          type: "submit",
                          disabled: _ctx.isSubmitting,
                          class: "flex-1 px-5 py-3 bg-primary-500 hover:bg-primary-600 disabled:bg-primary-300 text-white text-sm font-semibold rounded-xl transition-colors flex items-center justify-center gap-2"
                        }, [
                          (_ctx.isSubmitting)
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_33, [...(_cache[25] || (_cache[25] = [
                                _createElementVNode("circle", {
                                  class: "opacity-25",
                                  cx: "12",
                                  cy: "12",
                                  r: "10",
                                  stroke: "currentColor",
                                  "stroke-width": "4"
                                }, null, -1),
                                _createElementVNode("path", {
                                  class: "opacity-75",
                                  fill: "currentColor",
                                  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                                }, null, -1)
                              ]))]))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(_ctx.isSubmitting ? 'Submitting...' : 'Publish Review'), 1)
                        ], 8, _hoisted_32)
                      ])
                    ], 32))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}